class ImageCoverCtrl extends ViewBasic {
	constructor(options) {
		super(options);

		this.defaults = {
			isBackground:            false,
			focusTop:                '50%',
			focusLeft:               '50%',
			fixedBackground:         false,
			topRequiredSpace:        0,
			desktopBackgroundWidth:  '120%',
			desktopBackgroundHeight: 0,
			mobileBackgroundWidth:   0,
			mobileBackgroundHeight:  0
		};

		Me.dispatch.subscribe('resize', $.proxy(this.resize, this));
	}

	init() {
		this.addEvents();
	}

	addEvents() {
	}

	removeEvents() {

	}

	resize(){
		this.$el.width('auto');
		this.$el.height('auto');
		this.$el.css('transform', 'none');

		ImageHelper.fitImageInParent(this.$el, this.defaults.focusTop, this.defaults.focusLeft, this.defaults.isBackground,  parseInt(this.defaults.desktopBackgroundWidth),  parseInt(this.defaults.desktopBackgroundHeight), this.defaults.fixedBackground, parseInt(this.defaults.topRequiredSpace));
	}
}